import { render, staticRenderFns } from "./LoadingProgress.vue?vue&type=template&id=5d1ff20f&scoped=true&"
import script from "./LoadingProgress.vue?vue&type=script&lang=js&"
export * from "./LoadingProgress.vue?vue&type=script&lang=js&"
import style0 from "./LoadingProgress.vue?vue&type=style&index=0&id=5d1ff20f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1ff20f",
  null
  
)

export default component.exports